import { Button } from "@mychili/clarity-ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PromoBannerMobile } from "../../features/promo-banner";
import { analytics } from "../../shared/lib/analytics";
import { ROUTES } from "../../shared/routing/routing";
import logoIconImage from "./assets/logo-icon.svg";

type PaymentViewMobileProps = {
  link?: string;
  disallowPromocodes: boolean;
  isWebFlowAllowed: boolean;
};

export const PaymentViewMobile = ({
  link,
  disallowPromocodes,
  isWebFlowAllowed,
}: PaymentViewMobileProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    analytics.log("PressPayInAppButton");

    if (link) window.location.href = link;
  };

  const handleContinueInBrowserClick = () => {
    analytics.log("PressContinueInBrowserButton", {
      platform: "mobile",
    });

    navigate(ROUTES.fakedoor);
  };

  useEffect(() => {
    if (link) {
      analytics.log("ShowPayInAppButton");
    }
  }, [link]);

  useEffect(() => {
    if (isWebFlowAllowed) {
      analytics.log("ShowContinueInBrowserButton", {
        platform: "mobile",
      });
    }
  }, [isWebFlowAllowed]);

  return (
    <div className="flex h-full w-full flex-col">
      <div className="mt-auto mb-4 flex flex-col items-center gap-2">
        <img
          className="w-[92px]"
          src="https://static.ahapay.my/logos/full.svg"
          alt="logo"
        />
        <p className="typography-big-text-semibold mx-10 text-center text-text-neutral">
          {t("payment.mobile.title")}
        </p>
      </div>

      {!disallowPromocodes && <PromoBannerMobile />}

      {link && (
        <div className="mt-auto flex flex-col gap-3 bg-background-neutral p-5">
          <Button onClick={handleClick}>
            <img src={logoIconImage} alt="logo_icon" />
            {t("payment.app_button_text")}
          </Button>
          {isWebFlowAllowed && (
            <Button variant="secondary" onClick={handleContinueInBrowserClick}>
              {t("payment.continue_button_text")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
